const LABELS = Object.freeze({ MYR: 'RM', USD: 'USD', SAR: 'SAR', AED: 'AED' });
const numbers = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function currencyLabel(currency) {
  if (!Object.prototype.hasOwnProperty.call(LABELS, currency)) {
    throw new Error('Restaurant reporting currency is missing or unsupported.');
  }
  return LABELS[currency];
}

export function formatReportCurrency(amount, currency) {
  if (typeof amount !== 'number' || !Number.isFinite(amount)) throw new Error('Invalid report amount.');
  return `${currencyLabel(currency)} ${numbers.format(amount)}`;
}

export function reportCurrencyNumberFormat(currency) {
  const label = currencyLabel(currency);
  return `"${label}" #,##0.00;-"${label}" #,##0.00;"${label}" 0.00`;
}
